export default function orderDataPreparation(order) {
  const { goods } = order;
  let data = `name=${order.name}&email=${order.email}&phone=${order.phone}&pickup=${order.pickup}&deliveryService=${order.deliveryService}&city=${order.post_city}&cityId=${order.post_cityId}&address=${order.post_address}&comment=${order.comment}&traderCode=${order.traderCode}&payment=${order.payment}&pvzCode=`;

  // eslint-disable-next-line no-restricted-syntax
  for (const key in goods) {
    if (Object.prototype.hasOwnProperty.call(goods, key)) {
      data += `&goods[${key}][id]=${goods[key].shopGood}`;
      data += `&goods[${key}][count]=${goods[key].count}`;
    }
  }
  return data;
}
